// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1UuJW","title":"ClientInsurance_title__3721b","itemText":"ClientInsurance_itemText__2Ai5U"};